import { render, staticRenderFns } from "./RuleDeleteDialog.vue?vue&type=template&id=0a804701&scoped=true"
import script from "./RuleDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./RuleDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./RuleDeleteDialog.vue?vue&type=style&index=0&id=0a804701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a804701",
  null
  
)

export default component.exports